import InsightsGeneratePagination from "./insightsGeneratePagination";
import InsightsPagination from "./insightsPagination";

export default function() {
  // get filter buttons
  const filterButtons = document.querySelectorAll(".js-insightsFilter");
  const eventsConferencesFilterButton = document.querySelectorAll(
    ".js-insightsFilter[data-filter='events_conferences']"
  )[0];
  const blogFilterButton = document.querySelectorAll(
    ".js-insightsFilter[data-filter='blog']"
  )[0];
  const pressReleasesFilterButton = document.querySelectorAll(
    ".js-insightsFilter[data-filter='press_releases']"
  )[0];
  const videosFilterButton = document.querySelectorAll(
    ".js-insightsFilter[data-filter='videos']"
  )[0];
  const whitepapersFilterButton = document.querySelectorAll(
    ".js-insightsFilter[data-filter='whitepapers']"
  )[0];
  const surveysFilterButton = document.querySelectorAll(
    ".js-insightsFilter[data-filter='surveys']"
  )[0];

  // get various post types
  const allPosts = document.querySelectorAll(".b-allInsights__item");
  const eventsConferencesItems = document.querySelectorAll(
    ".b-allInsights__item.events_conferences"
  );
  const blogItems = document.querySelectorAll(".b-allInsights__item.blog");
  const pressReleaseItems = document.querySelectorAll(
    ".b-allInsights__item.press_releases"
  );
  const videoItems = document.querySelectorAll(".b-allInsights__item.videos");
  const whitepaperItems = document.querySelectorAll(
    ".b-allInsights__item.press_releases"
  );
  const surveyItems = document.querySelectorAll(".b-allInsights__item.surveys");

  // hide filter button if no items for that particular post type
  if (eventsConferencesItems.length === 0) {
    eventsConferencesFilterButton.style.display = "none";
  }
  if (blogItems.length === 0) {
    blogFilterButton.style.display = "none";
  }
  if (pressReleaseItems.length === 0) {
    pressReleasesFilterButton.style.display = "none";
  }
  if (videoItems.length === 0) {
    videosFilterButton.style.display = "none";
  }
  if (whitepaperItems.length === 0) {
    whitepapersFilterButton.style.display = "none";
  }
  if (surveyItems.length === 0) {
    surveysFilterButton.style.display = "none";
  }

  // helper function to loop over nodeLists to add event handlers
  function addEventListenerList(list, event, fn) {
    for (let i = 0, len = list.length; i < len; i += 1) {
      list[i].addEventListener(event, fn, false);
    }
  }

  // helper function to help convert nodelist to array
  // forEach method, could be shipped as part of an Object Literal/Module
  function nodelistForEach(array, callback, scope) {
    for (let i = 0; i < array.length; i += 1) {
      callback.call(scope, i, array[i]); // passes back stuff we need
    }
  }

  // init arrays
  const selectedFilters = [];
  const postsMatchingFilters = [];

  // click handler for filter buttons
  function handleFilterClick(e) {
    e.preventDefault();

    // check if filter is already selected
    const isSelected = this.classList.contains("filter--isSelected");
    // console.log(this);

    // get the data attribute
    const postType = this.dataset.filter;
    // console.log(`Filtering: ${postType}`);

    // based on whether it is currently selected
    if (isSelected) {
      // console.log("already selected");
      this.classList.remove("filter--isSelected");
      // get index of array item that is postType
      const index = selectedFilters.indexOf(postType);
      // then remove it from array of selected filters
      selectedFilters.splice(index, 1);

      // remove items from postsMatchingFilters
      const items = document.querySelectorAll(
        `.b-allInsights__item.${postType}`
      );
      nodelistForEach(items, function(index, value) {
        const index2 = postsMatchingFilters.indexOf(value);
        postsMatchingFilters.splice(index2, 1);
      });
    } else {
      this.classList.add("filter--isSelected");
      // and add to array of selected filters
      selectedFilters.push(postType);
      // console.log(`selected filters are ${selectedFilters}`);

      // add items to postsMatchingFilters
      const items = document.querySelectorAll(
        `.b-allInsights__item.${postType}`
      );
      nodelistForEach(items, function(index, value) {
        postsMatchingFilters.push(value);
      });
    }

    // loop over all Posts nodelist and make an array
    const allPostsArray = [];
    nodelistForEach(allPosts, function(index, value) {
      allPostsArray.push(value);
    });

    // if no filters are selected, reset all the isHidden classes
    if (selectedFilters.length === 0) {
      // console.log("filters cleared");
      const allPostsArrayLength = allPostsArray.length;
      for (let i = 0; i < allPostsArrayLength; i += 1) {
        allPostsArray[i].classList.remove("isHidden");
      }
      // reset pagination
      setTimeout(function() {
        InsightsGeneratePagination();
        InsightsPagination();
      }, 550);
    } else {
      console.log(allPostsArray);
      console.log(postsMatchingFilters);

      // all posts, intersect with itemsMatchingFilters, gives you posts to hide
      const postsToHide = allPostsArray.filter(function(item) {
        console.log(indexOf);
        const indexOf = postsMatchingFilters.indexOf(item);
        console.log(indexOf);
        return !(postsMatchingFilters.indexOf(item) >= 0);
      });
      console.log("posts to hide");
      console.log(postsToHide);
      // loop over posts to hide and add class
      let length = postsToHide.length;
      for (let i = 0; i < length; i += 1) {
        postsToHide[i].classList.add("isHiding");
        setTimeout(function() {
          postsToHide[i].classList.add("isHidden");
          postsToHide[i].classList.remove("isHiding");
        }, 500); //Same time as animation
      }
      // loop over posts to hide and add class
      length = postsMatchingFilters.length;
      for (let i = 0; i < length; i += 1) {
        postsMatchingFilters[i].classList.remove("isHidden");
      }
      // reset pagination
      setTimeout(function() {
        // console.log("pagination reset cos filters clicked");
        InsightsGeneratePagination();
        InsightsPagination();
      }, 750);
    }
  }

  addEventListenerList(filterButtons, "click", handleFilterClick);
}



// WEBPACK FOOTER //
// ./assets/scripts/modules/insightsFilter.js